import tutorials from '../../plugins/protokol/components/tutorials'
import Vue from 'vue'

const components = {
    state: {
        tutorial: null,
        showTutorial: false,
        viewMore: false,
        done: {},
        tutorials: tutorials
    },
    actions: {
        async initTutorial({commit, getters, dispatch}, tutorial) {
            await dispatch("fetchUserConfigs")
            const tuts = getters.userConfig("tutorial")

            if (tuts.length < 1) {
                commit('START_TUTORIAL', tutorial)
            }

            if (tuts.length > 0) {
                const { data } = tuts[0]

                commit('SET_TUTORIALS_DONE', data)

                if (!data[tutorial] && !data.dontshow) {
                    commit('START_TUTORIAL', tutorial)
                }
            }
        },

        async tutorialSkipped({state, commit, dispatch}) {
            commit("SET_TUTORIAL_DONE", state.tutorial)
            commit("CLOSE_TUTORIAL")

            dispatch("updateUserConfig", {path: "tutorial", data: state.done})
        },

        async dontShowTutorials({state, commit, dispatch}) {
            commit("SET_TUTORIAL_DONE", "dontshow")
            commit("CLOSE_TUTORIAL")

            dispatch("updateUserConfig", {path: "tutorial", data: state.done})
        }
    },
    mutations: {
       START_TUTORIAL(state, tutorial) {
           state.tutorial = tutorial
           state.showTutorial = true
       },

       CLOSE_TUTORIAL(state) {
            Vue.set(state, 'tutorial', null)
            Vue.set(state, 'showTutorial', false)
       },

       OPEN_TUTORIAL(state) {
            state.showTutorial = true
       },

       SET_TUTORIALS_DONE(state, done) {
            Vue.set(state, 'done', done)
       },

       SET_TUTORIAL_DONE(state, tut) {
            state.done[tut] = true
       },

       SET_VIEW_MORE_TUTORIALS(state, val) {
            state.viewMore = val
       }
    },
    getters: {
        getCurrentTutorialName(state) {
            return state.tutorial
        },

        getShowTutorial(state) {
            return state.showTutorial
        },

        getTutorials(state) {
            return state.tutorials
        },

        getCurrentTutorial(state) {
            return state.tutorials[state.tutorial]
        },

        getViewMoreTutorials(state) {
            return state.viewMore
        },

        getDoneTutorials(state) {
            return state.done
        }
    }
  }

export default components;